var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUltralyticsYoloLogomarkOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 512,
    viewBox: "0 0 502 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.519 0.00164032C52.7182 0.00164032 2.37702e-05 52.7442 2.37702e-05 117.574C2.37702e-05 182.399 52.7182 235.143 117.519 235.143C182.321 235.143 235.039 182.399 235.039 117.574C235.039 52.7442 182.321 0.00164032 117.519 0.00164032Z",
    fill: "#0B23A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.48 368.161C208.148 368.161 168.149 357.438 133.037 338.611V391.952C133.037 456.681 184.7 510.389 249.398 511.015C314.73 511.646 368.079 458.662 368.079 393.451V338.561C332.934 357.435 292.87 368.161 250.48 368.161Z",
    fill: "#0B23A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.858 117.587C265.736 199.375 199.369 265.797 117.324 265.997C85.6747 266.079 55.9756 256.222 31.74 239.014C74.6953 315.833 156.661 368.211 250.384 368.029C386.532 368.137 498.875 257.242 501.144 121.232L500.822 120.941C500.956 117.552 500.79 120.328 500.956 117.552C501.021 52.6767 448.222 -0.271502 383.697 -0.0456303C318.558 0.211597 265.923 52.711 265.858 117.587Z",
    fill: "url(#paint0_linear_10_168)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_168",
    x1: 142.137,
    y1: 363.87,
    x2: 433.123,
    y2: 41.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09DBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B23A9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 502,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltralyticsYoloLogomarkOriginal);
export default __webpack_public_path__ + "static/media/Ultralytics_YOLO_Logomark_Original.e705b3d7595c97c76f33dd00cccd63b8.svg";
export { ForwardRef as ReactComponent };